<div class="card" [formGroup]="form">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.BasicInfo" | translate }}
                </h5>
            </div>
            <div class="col-md-4">
                <button
                    class="btn btn-success btn-action pull-right"
                    [disabled]="!isFormValid()"
                    type="button"
                    bcClick
                    hznTestId="camp-basic-info-save"
                    (clicked)="save()"
                >
                    {{ "General.Save" | translate }}
                </button>
                <button
                    class="btn btn-danger btn-action pull-right mr-1"
                    type="button"
                    bcClick
                    (clicked)="cancel()"
                >
                    {{ "General.Cancel" | translate }}
                </button>
            </div>
        </div>
        <div class="card-text">
            <div class="row mt-2">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.Status" | translate }}
                </div>
                <div class="col-sm-10">
                    <select
                        hznTestId="camp-basic-info-status-select"
                        (change)="changeStatus($event.target.value)"
                        class="form-control"
                    >
                        @for (status of context.campStatuses; track status) {
                            <option
                                [value]="status"
                                [selected]="
                                    form.controls.status.value == status
                                "
                            >
                                {{ translateStatus(status) }}
                            </option>
                        }
                    </select>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.UniqueName" | translate }}
                </div>
                <div class="col-sm-10">
                    <input
                        class="form-control"
                        hznTestId="camp-basic-info-name-input"
                        formControlName="name"
                        maxlength="160"
                    />
                </div>
            </div>
            <div class="row mt-2 mb-2">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.HoldingAccount" | translate }}
                </div>
                <div class="col-sm-10">
                    <select
                        class="form-control"
                        hznTestId="camp-basic-info-holding-account"
                        formControlName="holdingAccount"
                    >
                        <option [value]="null" disabled hidden>
                            {{ "CampDetails.SelectHoldingAccount" | translate }}
                        </option>
                        @for (
                            holdingAccount of holdingAccounts();
                            track holdingAccount
                        ) {
                            <option [value]="holdingAccount.code">
                                {{ holdingAccount.code }}
                            </option>
                        }
                    </select>
                </div>
            </div>
            <div class="row mt-2 mb-2">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.RevenueDepartment" | translate }}
                </div>
                <div class="col-sm-10">
                    <select
                        class="form-control"
                        hznTestId="camp-basic-info-revenue-department"
                        formControlName="revenueDepartment"
                    >
                        <option [value]="null" disabled hidden>
                            {{
                                (hasHoldingAccount
                                    ? "CampDetails.SelectRevenueDepartment"
                                    : "CampDetails.SelectHoldingAccount"
                                ) | translate
                            }}
                        </option>
                        @for (code of revenueDepartmentCodes(); track code) {
                            <option [value]="code">{{ code }}</option>
                        }
                    </select>
                </div>
            </div>

            @if (isChildcareCamp) {
                <div class="row mt-2">
                    <div class="col-sm-2 bolded">
                        {{
                            "CampDetails.ReservationDaysAheadLimitVariant"
                                | translate
                        }}
                    </div>
                    <div class="col-sm-10">
                        <select
                            (change)="changeVariant($event.target.value)"
                            class="form-control"
                        >
                            @for (
                                variant of context.reservationDaysAheadLimitVariants;
                                track variant
                            ) {
                                <option
                                    [value]="variant"
                                    [selected]="
                                        form.controls
                                            .reservationDaysAheadLimitVariant
                                            .value == variant
                                    "
                                >
                                    {{
                                        translateReservationDaysAheadLimitVariant(
                                            variant
                                        )
                                    }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
            }

            @if (isChildcareCamp) {
                <div class="row mt-2">
                    <div class="col-sm-2 bolded">
                        {{
                            "CampDetails.ReservationDaysAheadLimit" | translate
                        }}
                    </div>
                    <div class="col-sm-10">
                        <input
                            type="number"
                            class="form-control"
                            formControlName="reservationDaysAheadLimit"
                            min="1"
                            step="1"
                            max="99999"
                            numbersOnly="99999"
                        />
                    </div>
                </div>
            }
            <app-camp-category-edit
                [form]="categoryForm"
                [parentCategories]="parentCategories()"
                [subcategories]="subcategories()"
            ></app-camp-category-edit>
        </div>
    </div>
</div>
